import { TableBody as MUITableBody } from '@mui/material';

import { TableRow } from './TableRow';

export const TableBody = ({
  isManager,
  reports,
  selectedApptIDs,
  onSelectRow,
  openActivityLogModal,
  openRescheduleDemoModal,
  onChangeReports,
  filterByStatuses,
}) => {
  return (
    <MUITableBody>
      {reports.map((report, idx) => {
        const isRowChecked = selectedApptIDs.includes(report.ApptID);
        const withBorderBottom = reports.length !== idx + 1;

        return (
          <TableRow
            key={report.ApptID}
            report={report}
            isRowChecked={isRowChecked}
            withBorderBottom={withBorderBottom}
            isManager={isManager}
            onSelectRow={onSelectRow}
            openActivityLogModal={openActivityLogModal}
            openRescheduleDemoModal={openRescheduleDemoModal}
            onChangeReports={onChangeReports}
            filterByStatuses={filterByStatuses}
          />
        );
      })}
    </MUITableBody>
  );
};
